"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/modules/featureFlags/index.ts
var featureFlags_exports = {};
__export(featureFlags_exports, {
  DEV_TOOL_STORE_KEY: () => DEV_TOOL_STORE_KEY,
  DevTool: () => DevTool,
  FeatureFlagGrid: () => FeatureFlagGrid,
  FeatureFlagsProvider: () => FeatureFlagsProvider,
  createFlag: () => createFlag,
  getFeatureFlags: () => getFeatureFlags,
  getFlagValue: () => getFlagValue,
  setDefaultFeatureFlags: () => setDefaultFeatureFlags,
  setFlagValue: () => setFlagValue,
  useFlagValue: () => useFlagValue
});
module.exports = __toCommonJS(featureFlags_exports);

// src/modules/featureFlags/FLAG_DEFINITIONS.ts
var FLAG_DEFINITIONS_exports = {};
__export(FLAG_DEFINITIONS_exports, {
  BRUM_SESSION_TROUBLESHOOTING: () => BRUM_SESSION_TROUBLESHOOTING,
  DASHBOARDS_ENABLED: () => DASHBOARDS_ENABLED,
  DEMO_ENABLE_AWS_OVERVIEW: () => DEMO_ENABLE_AWS_OVERVIEW,
  ENABLE_AI_ASSISTANT: () => ENABLE_AI_ASSISTANT,
  ENABLE_AI_MODAL: () => ENABLE_AI_MODAL,
  ENABLE_AI_TRAINING: () => ENABLE_AI_TRAINING,
  FSOMON_ENABLED: () => FSOMON_ENABLED,
  LIGHT_THEME: () => LIGHT_THEME,
  LOG_PROCESSING_ENABLED: () => LOG_PROCESSING_ENABLED,
  MASKING_CONFIG_ENABLED: () => MASKING_CONFIG_ENABLED,
  METRIC_EXPLORER_ENABLED: () => METRIC_EXPLORER_ENABLED,
  PAGE_HEADER_ENABLED: () => PAGE_HEADER_ENABLED,
  QUERY_BUILDER_ENABLED: () => QUERY_BUILDER_ENABLED,
  SCHEMA_BROWSER_ENABLED: () => SCHEMA_BROWSER_ENABLED,
  SHOW_TEMPLATE_AUTHORING: () => SHOW_TEMPLATE_AUTHORING,
  TELEMETRY_ENABLED: () => TELEMETRY_ENABLED,
  Z__DEMO_HIDE_DEV_TOOL_STATUS__: () => Z__DEMO_HIDE_DEV_TOOL_STATUS__,
  Z__DEMO_TEST_FLAG_FOR_NEXT__: () => Z__DEMO_TEST_FLAG_FOR_NEXT__,
  Z__GRID_ELEMENT_LIMITER__: () => Z__GRID_ELEMENT_LIMITER__,
  Z__TEST_NUMBER_FLAG__: () => Z__TEST_NUMBER_FLAG__,
  Z__TEST_STRING_FLAG__: () => Z__TEST_STRING_FLAG__
});

// src/modules/featureFlags/createFlag.ts
function createFlag(definition) {
  return Object.freeze({
    defaultValue: definition.defaultValue,
    description: definition.description,
    remoteFlagName: definition.remoteFlagName ?? ""
  });
}
__name(createFlag, "createFlag");

// src/modules/featureFlags/FLAG_DEFINITIONS.ts
var LIGHT_THEME = createFlag({
  remoteFlagName: "ui.lighttheme.enabled",
  description: "Enable light theme",
  defaultValue: true
});
var DASHBOARDS_ENABLED = createFlag({
  remoteFlagName: "ui.dashboards.features",
  description: "Toggle all dashboards related features",
  defaultValue: true
});
var SCHEMA_BROWSER_ENABLED = createFlag({
  remoteFlagName: "tools.melt.schema-browser.enabled",
  description: "feature flag to enable and disable schema browser",
  defaultValue: false
});
var QUERY_BUILDER_ENABLED = createFlag({
  remoteFlagName: "tools.melt.query-builder.enabled",
  description: "feature flag to enable and disable query builder",
  defaultValue: false
});
var METRIC_EXPLORER_ENABLED = createFlag({
  remoteFlagName: "tools.melt.metric-explorer.enabled",
  description: "feature flag to enable and disable metric explorer",
  defaultValue: false
});
var LOG_PROCESSING_ENABLED = createFlag({
  remoteFlagName: "log.processing.enabled",
  description: "faeture flag to enable and disable Log processing page",
  defaultValue: true
});
var SHOW_TEMPLATE_AUTHORING = createFlag({
  description: "Show the Authoring Editor for Templates. Hide URL in LeftNav + avoid rendering on /authoring",
  defaultValue: false,
  remoteFlagName: "ui.template.authoring.enabled"
});
var FSOMON_ENABLED = createFlag({
  remoteFlagName: "ui.dashboards.fsomon",
  description: "Toggle FSO Platform Monitoring",
  defaultValue: false
});
var DEMO_ENABLE_AWS_OVERVIEW = createFlag({
  description: "DEMO - Show the aws overview on left nav",
  defaultValue: false
});
var BRUM_SESSION_TROUBLESHOOTING = createFlag({
  description: "Enables Session troubleshooting feature to become visible in the UI",
  defaultValue: false,
  remoteFlagName: "brum.session.troubleshooting.enabled"
});
var MASKING_CONFIG_ENABLED = createFlag({
  remoteFlagName: "masking.config.enabled",
  description: "faeture flag to enable and disable data masking configuration",
  defaultValue: true
});
var PAGE_HEADER_ENABLED = createFlag({
  description: "feature flag to enable page header with title, breadcrumbs and time range",
  defaultValue: true,
  remoteFlagName: "page.header.enabled"
});
var ENABLE_AI_ASSISTANT = createFlag({
  description: "Flag to enable AI assistant",
  defaultValue: false,
  remoteFlagName: "ai.assistant.enabled"
});
var ENABLE_AI_MODAL = createFlag({
  description: "feature flag to enable ai modal from the top nav",
  defaultValue: false,
  remoteFlagName: "ai.modal.enabled"
});
var ENABLE_AI_TRAINING = createFlag({
  description: "feature flag to enable ai training from the ai modal",
  defaultValue: false,
  remoteFlagName: "ai.training.enabled"
});
var TELEMETRY_ENABLED = createFlag({
  description: "feature flag to enable telemetry",
  defaultValue: false,
  remoteFlagName: "ui.tracking.next-ui.enabled"
});
var Z__GRID_ELEMENT_LIMITER__ = createFlag({
  description: "Enable the flag via enabled and change count of grid rows via value for /dev/tool grid",
  defaultValue: { value: 5, enabled: false }
});
var Z__TEST_STRING_FLAG__ = createFlag({
  description: "DO NOT DELETE THIS FLAG",
  defaultValue: { value: "test" }
});
var Z__TEST_NUMBER_FLAG__ = createFlag({
  description: "DO NOT DELETE THIS FLAG",
  defaultValue: { value: 0 }
});
var Z__DEMO_HIDE_DEV_TOOL_STATUS__ = createFlag({
  description: "DEMO - Hide the DevTool status on /dev/tool",
  defaultValue: false
});
var Z__DEMO_TEST_FLAG_FOR_NEXT__ = createFlag({
  description: "DEMO flag for testing in Next",
  defaultValue: true,
  remoteFlagName: "test.demo.flag"
});

// src/modules/featureFlags/FeatureFlagsUtils.ts
var getFeatureFlags = /* @__PURE__ */ __name((featureFlagsStoreKey) => {
  const featureFlags = localStorage.getItem(featureFlagsStoreKey);
  return featureFlags === null ? void 0 : JSON.parse(featureFlags);
}, "getFeatureFlags");
var setDefaultFeatureFlags = /* @__PURE__ */ __name((featureFlagsStoreKey, flagDefinitionsFromConfig) => {
  const flagNameWithCurrentValue = defaultValuesFromDefinitions(
    Object.keys(FLAG_DEFINITIONS_exports),
    flagDefinitionsFromConfig
  );
  updateLocalStorage(featureFlagsStoreKey, flagNameWithCurrentValue);
}, "setDefaultFeatureFlags");
var resetLocalStorageFlags = /* @__PURE__ */ __name((featureFlagsStoreKey, flagDefinitionsFromConfig) => {
  localStorage.removeItem(featureFlagsStoreKey);
  setDefaultFeatureFlags(featureFlagsStoreKey, flagDefinitionsFromConfig);
}, "resetLocalStorageFlags");
var updateFeatureFlagsFromDefinitions = /* @__PURE__ */ __name((featureFlagsStoreKey, flagDefinitionsFromConfig) => {
  const flagsFromLocalStorage = getFeatureFlags(featureFlagsStoreKey);
  if (flagsFromLocalStorage !== void 0) {
    const newFlags = Object.keys({ ...FLAG_DEFINITIONS_exports, ...flagDefinitionsFromConfig }).filter(
      (key) => !Object.keys(flagsFromLocalStorage).includes(key)
    );
    const flagsWithDefaultValues = defaultValuesFromDefinitions(newFlags, flagDefinitionsFromConfig);
    const updatedFeatureFlagsToBeStored = {
      ...flagsWithDefaultValues,
      ...flagsFromLocalStorage
    };
    updateLocalStorage(featureFlagsStoreKey, updatedFeatureFlagsToBeStored);
  }
}, "updateFeatureFlagsFromDefinitions");
var setFlagValue = /* @__PURE__ */ __name((featureFlagsStoreKey, flagName, value) => {
  const defaultFlags = getFeatureFlags(featureFlagsStoreKey);
  if (defaultFlags !== void 0 && defaultFlags[flagName] != null) {
    defaultFlags[flagName].overriddenValue = value;
    updateLocalStorage(featureFlagsStoreKey, defaultFlags);
  }
}, "setFlagValue");
var setDefaultFlagValue = /* @__PURE__ */ __name((featureFlagsStoreKey, flagName, value) => {
  const defaultFlags = getFeatureFlags(featureFlagsStoreKey);
  if (defaultFlags !== void 0 && defaultFlags[flagName] != null) {
    defaultFlags[flagName].value = value;
    updateLocalStorage(featureFlagsStoreKey, defaultFlags);
  }
}, "setDefaultFlagValue");
var getFlagValue = /* @__PURE__ */ __name((featureFlagsStoreKey, flagName, updatedFeatureFlags) => {
  const defaultFlags = updatedFeatureFlags ?? getFeatureFlags(featureFlagsStoreKey);
  if (defaultFlags !== void 0 && defaultFlags[flagName] != null) {
    const overrideValueFromLocalStorage = defaultFlags[flagName].overriddenValue;
    if (overrideValueFromLocalStorage == null) {
      return defaultFlags[flagName].value;
    }
    return overrideValueFromLocalStorage;
  }
  return FLAG_DEFINITIONS_exports[flagName]?.defaultValue;
}, "getFlagValue");
function defaultValuesFromDefinitions(flags, definitionsFromConfig) {
  const mergedKeys = [.../* @__PURE__ */ new Set([...flags, ...Object.keys(definitionsFromConfig || {})])];
  return mergedKeys.reduce((prevObj, cur) => {
    const defaultValue = definitionsFromConfig?.[cur]?.defaultValue ?? FLAG_DEFINITIONS_exports[cur].defaultValue;
    return {
      ...prevObj,
      [cur]: {
        value: defaultValue
      }
    };
  }, {});
}
__name(defaultValuesFromDefinitions, "defaultValuesFromDefinitions");
function updateLocalStorage(featureFlagsStoreKey, flagNameWithCurrentValue) {
  localStorage.setItem(featureFlagsStoreKey, JSON.stringify(flagNameWithCurrentValue));
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: featureFlagsStoreKey,
      newValue: JSON.stringify(flagNameWithCurrentValue)
    })
  );
}
__name(updateLocalStorage, "updateLocalStorage");

// src/modules/featureFlags/hooks/useFlagValue.ts
var import_react = require("react");
var useFlagValue = /* @__PURE__ */ __name((flagsStoreKey, flagName) => {
  const [flagValue, setFlagValue2] = (0, import_react.useState)(getFlagValue(flagsStoreKey, flagName));
  (0, import_react.useLayoutEffect)(() => {
    const listener = /* @__PURE__ */ __name((event) => {
      if (event.key !== flagsStoreKey) {
        return;
      }
      const defaultFlags = JSON.parse(event.newValue ?? "{}");
      setFlagValue2(getFlagValue(flagsStoreKey, flagName, defaultFlags));
    }, "listener");
    window.addEventListener("storage", listener);
    return () => {
      window.removeEventListener("storage", listener);
    };
  }, [flagName, flagsStoreKey]);
  return flagValue;
}, "useFlagValue");

// src/modules/featureFlags/FeatureFlags.ts
var DEV_TOOL_STORE_KEY = "fso-ui-shell-feature-flag-dev-console";
var OLD_NEXT_FEATURE_FLAG_STORE_KEY = "feature-flags-store";

// src/modules/featureFlags/components/DevTool.tsx
var import_uik8 = require("@appd/uik");
var import_react7 = require("react");

// src/modules/featureFlags/components/DevToolBar.tsx
var import_uik = require("@appd/uik");
var import_jsx_runtime = require("react/jsx-runtime");
var {
  TYPOGRAPHY: { P3_EMPHASIS },
  COLORS: { CONTROL_BORDER_WEAK, DEFAULT_TEXT, DEFAULT_TEXT_MEDIUM, INTERACT_TEXT_HOVER },
  SPACING
} = import_uik.MAGNETIC_TOKENS;
var { DEV_WARNING, FLAGS_BUTTON, DEV_INFO } = {
  DEV_WARNING: import_uik.css.Styles({
    alignItems: "center",
    color: DEFAULT_TEXT_MEDIUM,
    display: "flex",
    font: P3_EMPHASIS,
    height: 34,
    justifyContent: "space-between",
    marginRight: 30,
    width: "100%"
  }),
  DEV_INFO: import_uik.css.Styles({
    gap: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexGrow: 1,
    height: "100%",
    ":hover": {
      color: DEFAULT_TEXT_MEDIUM
    }
  }),
  FLAGS_BUTTON: import_uik.css.Styles({
    background: "transparent",
    border: "none",
    borderBottomStyle: "solid",
    borderBottomWidth: 3,
    borderBottomColor: CONTROL_BORDER_WEAK,
    color: DEFAULT_TEXT,
    cursor: "pointer",
    font: P3_EMPHASIS,
    paddingTop: SPACING[2],
    paddingBottom: SPACING[2],
    paddingLeft: SPACING[4],
    paddingRight: SPACING[4],
    ":hover": {
      color: INTERACT_TEXT_HOVER
    }
  })
};
var DevToolBar = /* @__PURE__ */ __name(({ open, onCloseIconClick, onClick }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { role: "button", tabIndex: 0, onClick, className: (0, import_uik.css)({ ...DEV_WARNING }), children: [
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", { type: "button", className: (0, import_uik.css)({ ...FLAGS_BUTTON }), children: "Flags" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: (0, import_uik.css)({ ...DEV_INFO }), children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { children: [
      "Internal development tool. This is ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("strong", { children: "not" }),
      " part of the AppDynamics product."
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_uik.Icon, { type: open ? "Navigation.ArrowDropDown" : "Navigation.ArrowDropUp", size: "SMALL" }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_uik.Icon, { onClick: () => onCloseIconClick(), type: "Navigation.Close", size: "SMALL" })
  ] })
] }), "DevToolBar");

// src/modules/featureFlags/components/DevToolContent.tsx
var import_uik7 = require("@appd/uik");
var import_react6 = require("react");

// src/modules/featureFlags/components/DevToolHeader.tsx
var import_uik2 = require("@appd/uik");
var import_react2 = require("react");
var import_jsx_runtime2 = require("react/jsx-runtime");
var {
  COLORS: {
    CONTROL_BG_WEAK,
    CONTROL_BORDER_MEDIUM,
    CONTROL_BORDER_MEDIUM_FOCUS,
    CONTROL_ICON_MEDIUM,
    CONTROL_ICON_MEDIUM_FOCUS,
    CONTROL_ICON_MEDIUM_HOVER,
    DEFAULT_TEXT: DEFAULT_TEXT2,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM2
  },
  RADIUS,
  TYPOGRAPHY: { P3_DEFAULT },
  SPACING: SPACING2
} = import_uik2.MAGNETIC_TOKENS;
var { INPUT_BOX, SEARCH_ICON, CLEAR_ICON, INPUT, HEADER, RIGHT_CONTAINER, LEFT_CONTAINER } = {
  INPUT_BOX: (focus) => import_uik2.css.Styles({
    backgroundColor: CONTROL_BG_WEAK,
    color: DEFAULT_TEXT_MEDIUM2,
    font: P3_DEFAULT,
    minWidth: 200,
    height: 29,
    paddingLeft: SPACING2[1],
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: focus ? CONTROL_BORDER_MEDIUM_FOCUS : CONTROL_BORDER_MEDIUM,
    borderRadius: RADIUS.DEFAULT,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }),
  SEARCH_ICON: (focus) => import_uik2.css.Styles({
    paddingLeft: SPACING2[1],
    paddingRight: SPACING2[1],
    "& > svg > path": {
      fill: focus ? CONTROL_ICON_MEDIUM_FOCUS : CONTROL_ICON_MEDIUM
    }
  }),
  CLEAR_ICON: (focus) => import_uik2.css.Styles({
    display: "flex",
    alignItems: "center",
    borderRightStyle: "solid",
    borderRightWidth: 1,
    borderRightColor: focus ? CONTROL_BORDER_MEDIUM_FOCUS : CONTROL_BORDER_MEDIUM,
    height: "100%",
    paddingRight: SPACING2[1],
    cursor: "pointer",
    "& > svg > path": {
      fill: focus ? CONTROL_ICON_MEDIUM_FOCUS : CONTROL_ICON_MEDIUM
    },
    ":hover": {
      "& > svg > path": {
        fill: CONTROL_ICON_MEDIUM_HOVER
      }
    }
  }),
  INPUT: import_uik2.css.Styles({
    paddingLeft: SPACING2[1],
    color: DEFAULT_TEXT_MEDIUM2,
    backgroundColor: "transparent",
    flex: 1,
    font: P3_DEFAULT,
    border: "none",
    overflow: "hidden",
    ":focus": {
      color: DEFAULT_TEXT2,
      outline: "none"
    }
  }),
  HEADER: import_uik2.css.Styles({
    cursor: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingTop: SPACING2[2],
    paddingBottom: SPACING2[2],
    paddingLeft: SPACING2[3],
    paddingRight: SPACING2[3]
  }),
  RIGHT_CONTAINER: import_uik2.css.Styles({
    display: "inline-flex",
    alignItems: "center",
    gap: SPACING2[4]
  }),
  LEFT_CONTAINER: import_uik2.css.Styles({
    font: P3_DEFAULT
  })
};
var DevToolHeader = /* @__PURE__ */ __name(({
  input,
  setInput,
  handleClick,
  showDemoFlags,
  setShowDemoFlags
}) => {
  const [focus, setFocus] = (0, import_react2.useState)(false);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: (0, import_uik2.css)({ ...HEADER }), children: [
    /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: (0, import_uik2.css)({ ...LEFT_CONTAINER }), children: [
      "The flags below allow you to enable experimental user interface features. ",
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("br", {}),
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("b", { children: " Changing these flags may cause the application to malfunction! Use at your own risk. " }),
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("br", {}),
      "You may reset all settings to their default value at any time with the reset button on the right ",
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("br", {})
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: (0, import_uik2.css)({ ...RIGHT_CONTAINER }), children: [
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
        import_uik2.Checkbox,
        {
          label: "show demo Feature Flags",
          checked: showDemoFlags,
          onChange: () => setShowDemoFlags(!showDemoFlags)
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: (0, import_uik2.css)({ ...INPUT_BOX(focus) }), children: [
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          "input",
          {
            onFocus: () => setFocus((prev) => !prev),
            onBlur: () => setFocus((prev) => !prev),
            className: (0, import_uik2.css)({ ...INPUT }),
            type: "text",
            placeholder: "Search...",
            onChange: (e) => setInput(e.target.value),
            value: input
          }
        ),
        input.length !== 0 ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: (0, import_uik2.css)({ ...CLEAR_ICON(focus) }), children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_uik2.Icon, { onClick: () => setInput(""), type: "Navigation.Close", size: "SMALL" }) }) : null,
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: (0, import_uik2.css)({ ...SEARCH_ICON(focus) }), children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_uik2.Icon, { type: "Action.Search", size: "SMALL" }) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_uik2.Button, { onClick: () => handleClick(), children: "Reset Flags" })
    ] })
  ] });
}, "DevToolHeader");

// src/modules/featureFlags/components/FeatureFlagGrid.tsx
var import_uik6 = require("@appd/uik");
var import_react4 = require("react");

// src/modules/featureFlags/components/gridCellRenderer/RemoteFlagRenderer.tsx
var import_uik3 = require("@appd/uik");
var import_jsx_runtime3 = require("react/jsx-runtime");
var {
  SPACING: SPACING3,
  TYPOGRAPHY: { P3_EMPHASIS: P3_EMPHASIS2 }
} = import_uik3.MAGNETIC_TOKENS;
var REMOTE_WRAPPER = {
  alignItems: "center",
  display: "flex",
  font: P3_EMPHASIS2,
  gap: SPACING3[1]
};
var RemoteFlagRenderer = /* @__PURE__ */ __name(({ value }) => value !== void 0 ? /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("span", { className: (0, import_uik3.css)({ ...REMOTE_WRAPPER }), children: typeof value === "boolean" ? /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_jsx_runtime3.Fragment, { children: [
  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik3.Icon, { type: value ? "Status.Success" : "Status.Error" }),
  /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { children: [
    " - ",
    value ? "Flag is Enabled" : "Flag is Disabled"
  ] })
] }) : /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { children: " Multivariate Feature Flag" }) }) : /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { children: " Feature-Flag does not exist in LaunchDarkly " }), "RemoteFlagRenderer");

// src/modules/featureFlags/components/gridCellRenderer/SelectValueRenderer.tsx
var import_uik5 = require("@appd/uik");
var import_react3 = require("react");

// src/modules/featureFlags/components/SelectGridTrigger.tsx
var import_uik4 = require("@appd/uik");
var import_jsx_runtime4 = require("react/jsx-runtime");
var {
  COLORS: { DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM3, INTERACT_BG_WEAK, INTERACT_BORDER_WEAK }
} = import_uik4.MAGNETIC_TOKENS;
var { SELECT_VALUE_BUTTON, DISPLAY_VALUE, DROPDOWN_ICON } = {
  SELECT_VALUE_BUTTON: import_uik4.css.Styles({
    width: 285,
    background: INTERACT_BG_WEAK,
    borderBottomSize: 1,
    borderBottomStyle: "solid",
    borderBottomColor: INTERACT_BORDER_WEAK,
    borderRadius: 0
  }),
  DISPLAY_VALUE: import_uik4.css.Styles({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }),
  DROPDOWN_ICON: import_uik4.css.Styles({
    color: DEFAULT_TEXT_MEDIUM3
  })
};
var SelectGridTrigger = import_uik4.utils.forwardRef(
  ({ toggle, selected }, ref) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_uik4.Button, { type: "MENU_ITEM", className: (0, import_uik4.css)({ ...SELECT_VALUE_BUTTON }), ref, onClick: toggle, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("span", { className: (0, import_uik4.css)({ ...DISPLAY_VALUE }), children: [
    typeof selected === "string" ? selected : JSON.stringify(selected),
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_uik4.Icon, { className: (0, import_uik4.css)({ ...DROPDOWN_ICON }), type: "Navigation.ArrowDropDown" })
  ] }) })
);

// src/modules/featureFlags/components/gridCellRenderer/SelectValueRenderer.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var { SPACING: SPACING4 } = import_uik5.MAGNETIC_TOKENS;
var { MULTIVARIATE_WRAPPER, MULTIVARIATE_INPUT } = {
  MULTIVARIATE_WRAPPER: import_uik5.css.Styles({ display: "flex", gap: SPACING4[1], width: "100%" }),
  MULTIVARIATE_INPUT: import_uik5.css.Styles({ width: "100%", maxWidth: 250 })
};
var SelectValueRenderer = /* @__PURE__ */ __name((props) => {
  const { value, featureFlagsStoreKey } = props;
  const [visible, setVisible] = (0, import_react3.useState)(false);
  const [newFlagValue, setNewFlagValue] = (0, import_react3.useState)();
  const [errors, setErrors] = (0, import_react3.useState)([]);
  const nextFlagValue = useFlagValue(featureFlagsStoreKey, value);
  (0, import_react3.useEffect)(() => {
    if (typeof nextFlagValue === "boolean") {
      setNewFlagValue(nextFlagValue ? "Enabled" : "Disabled");
    }
    if (typeof nextFlagValue === "object") {
      setNewFlagValue(JSON.stringify(nextFlagValue));
    }
    return () => {
      setNewFlagValue("");
    };
  }, [nextFlagValue]);
  const options = [
    { label: "Enabled", value: true },
    { label: "Disabled", value: false }
  ];
  const handleClick = /* @__PURE__ */ __name((index) => () => {
    setVisible(false);
    setNewFlagValue(options[index].label);
    setFlagValue(featureFlagsStoreKey, value, options[index].value);
  }, "handleClick");
  const setInputValue = /* @__PURE__ */ __name((input) => {
    setNewFlagValue(input);
    setErrors([]);
  }, "setInputValue");
  const handleApply = /* @__PURE__ */ __name(() => {
    try {
      setFlagValue(
        featureFlagsStoreKey,
        value,
        JSON.parse(
          /**
           * inline check if input starts with '{' and ends with '}'
           * to provide falsy input which would be valid JSON e.g. a single number
           * multiline isn't supported with that, but we don't support multiline JSON in input-component yet
           *  */
          newFlagValue === void 0 || /^\{.*\}$/.test(newFlagValue) === false ? "{}" : newFlagValue
        )
      );
    } catch (e) {
      setErrors(["Invalid input for multivariate Feature Flag. Please provide valid JSON"]);
    }
  }, "handleApply");
  if (typeof nextFlagValue === "boolean") {
    const trigger = /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      SelectGridTrigger,
      {
        toggle: () => {
          setVisible(!visible);
        },
        selected: newFlagValue
      }
    );
    const content = /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_uik5.List, { children: options.map((option, index) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_uik5.List.Option, { onClick: handleClick(index), children: option.label }, `test-${String(option.label)}`)) });
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      import_uik5.Popover,
      {
        arrow: false,
        content,
        contentClassName: (0, import_uik5.css)({ padding: 0 }),
        position: "BOTTOM",
        trigger: "CLICK",
        visible,
        children: trigger
      }
    ) });
  }
  if (typeof nextFlagValue === "object") {
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: (0, import_uik5.css)(MULTIVARIATE_WRAPPER), children: [
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
        import_uik5.Input,
        {
          className: (0, import_uik5.css)(MULTIVARIATE_INPUT),
          value: newFlagValue ?? "",
          onChange: (event) => setInputValue(event.target.value),
          label: "",
          errors
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_uik5.Tooltip, { value: "Apply Changes", children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
        import_uik5.Button,
        {
          disabled: newFlagValue === JSON.stringify(nextFlagValue),
          onClick: handleApply,
          icon: "Action.Enable"
        }
      ) })
    ] });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", {});
}, "SelectValueRenderer");

// src/modules/featureFlags/components/FeatureFlagGrid.tsx
var import_jsx_runtime6 = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  require("react/jsx-runtime")
);
var FeatureFlagGrid = /* @__PURE__ */ __name(({
  input,
  showDemoFlags,
  featureFlagsStoreKey,
  flagDefinitions
}) => {
  const [data, setData] = (0, import_react4.useState)([]);
  const [gridData, setGridData] = (0, import_react4.useState)([]);
  const [remoteData, setRemoteData] = (0, import_react4.useState)();
  const demoFlag = useFlagValue(featureFlagsStoreKey, "Z__GRID_ELEMENT_LIMITER__");
  const globalWindow = globalThis;
  (0, import_react4.useEffect)(() => {
    if (typeof globalWindow.remoteFlagsPromise?.then === "function") {
      globalWindow.remoteFlagsPromise.then((remoteDataResponse) => {
        setRemoteData(remoteDataResponse);
      }).catch(console.error);
    }
  }, [globalWindow.remoteFlagsPromise]);
  const fetchData = (0, import_react4.useCallback)(() => {
    if (FLAG_DEFINITIONS_exports != null && remoteData !== void 0) {
      const combinedFlagDefinitions = { ...FLAG_DEFINITIONS_exports, ...flagDefinitions };
      const combinedKeys = Object.keys(combinedFlagDefinitions);
      return combinedKeys.filter((flagName) => flagName?.includes("Z__") !== true || showDemoFlags).sort().map((flagName) => {
        const { remoteFlagName, description, defaultValue } = combinedFlagDefinitions[flagName];
        let evaluation;
        if (typeof defaultValue === "boolean") {
          evaluation = remoteFlagName !== "" && remoteFlagName !== void 0 ? remoteData.getBooleanFlagVariationDetail(
            remoteFlagName,
            String(defaultValue).toLowerCase() === "true"
          ) : void 0;
        }
        if (typeof defaultValue === "object") {
          evaluation = remoteFlagName !== "" && remoteFlagName !== void 0 ? remoteData.getJSONFlagVariationDetail(remoteFlagName, defaultValue) : void 0;
        }
        const remoteFlagEvaluationStatus = evaluation?.getReason() === "Flag not found" ? void 0 : evaluation?.getValue();
        return {
          name: flagName,
          description,
          remote: remoteFlagEvaluationStatus,
          value: flagName
        };
      });
    }
    return [];
  }, [remoteData, showDemoFlags, flagDefinitions]);
  (0, import_react4.useEffect)(() => {
    setData(fetchData());
  }, [remoteData, fetchData]);
  (0, import_react4.useEffect)(() => {
    setGridData(
      data.filter((gridRow) => input != null ? gridRow.name.toLowerCase().includes(input.toLowerCase()) : gridRow.name)
    );
  }, [input, data]);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    import_uik6.Grid,
    {
      className: "grid",
      rowHeight: 60,
      columns: [
        { field: "name" },
        { field: "description" },
        { cellRenderer: RemoteFlagRenderer, field: "remote", headerName: "Remote (LaunchDarkly)", width: 350 },
        {
          width: 350,
          cellRenderer: SelectValueRenderer,
          cellRendererParams: {
            featureFlagsStoreKey
          },
          suppressKeyboardEvent: () => true,
          field: "value",
          headerName: "Current Value of Feature-Flag"
        }
      ],
      rows: demoFlag.enabled === true ? gridData.slice(0, typeof demoFlag.value === "number" ? demoFlag.value : gridData.length) : gridData
    }
  );
}, "FeatureFlagGrid");

// src/modules/featureFlags/FeatureFlagContext.ts
var import_react5 = require("react");
var FeatureFlagContext = (0, import_react5.createContext)(void 0);

// src/modules/featureFlags/components/DevToolContent.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var SPINNER = import_uik7.css.Styles({
  display: "flex",
  flexGrow: 1,
  alignItems: "center",
  justifyContent: "center",
  height: 200
});
var DevToolContent = /* @__PURE__ */ __name(({ featureFlagsStoreKey, flagDefinitions }) => {
  const [input, setInput] = (0, import_react6.useState)("");
  const [reset, setReset] = (0, import_react6.useState)(0);
  const [showDemoFlags, setShowDemoFlags] = (0, import_react6.useState)(false);
  const remoteFlagClient = (0, import_react6.useContext)(FeatureFlagContext);
  (0, import_react6.useEffect)(() => {
    if (reset % 2 !== 0) {
      setReset((prev) => prev + 1);
    }
  }, [reset]);
  const resetFlags = /* @__PURE__ */ __name(() => {
    resetLocalStorageFlags(featureFlagsStoreKey, flagDefinitions);
    if (remoteFlagClient === void 0) {
      return;
    }
    const combinedFlagDefinitions = { ...FLAG_DEFINITIONS_exports, ...flagDefinitions };
    const combinedKeys = Object.keys(combinedFlagDefinitions);
    combinedKeys.filter((flagName) => {
      const flagDef = combinedFlagDefinitions[flagName];
      return isFlagDefinition(flagDef) && flagDef.remoteFlagName === "";
    }).forEach((flagName) => {
      setDefaultFlagValue(featureFlagsStoreKey, flagName, combinedFlagDefinitions[flagName].defaultValue);
    });
    combinedKeys.filter((flagName) => combinedFlagDefinitions[flagName].remoteFlagName !== "").forEach((flagName) => {
      const { remoteFlagName, defaultValue } = combinedFlagDefinitions[flagName];
      if (typeof defaultValue === "boolean") {
        setDefaultFlagValue(
          featureFlagsStoreKey,
          flagName,
          remoteFlagClient.getBooleanFlagVariationDetail(remoteFlagName ?? "", String(defaultValue).toLowerCase() === "true").getValue()
        );
      }
      if (typeof defaultValue === "object") {
        setDefaultFlagValue(
          featureFlagsStoreKey,
          flagName,
          remoteFlagClient.getJSONFlagVariationDetail(remoteFlagName ?? "", defaultValue).getValue()
        );
      }
    });
  }, "resetFlags");
  const handleClick = /* @__PURE__ */ __name(() => {
    resetFlags();
    setReset((prev) => prev + 1);
  }, "handleClick");
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(import_jsx_runtime7.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      DevToolHeader,
      {
        input,
        setInput,
        handleClick,
        showDemoFlags,
        setShowDemoFlags
      }
    ),
    reset % 2 !== 0 ? /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_uik7.Spinner, { className: (0, import_uik7.css)({ ...SPINNER }), size: "SMALL", description: "Loading..." }) : /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      FeatureFlagGrid,
      {
        featureFlagsStoreKey,
        flagDefinitions,
        showDemoFlags,
        input
      }
    )
  ] });
}, "DevToolContent");
function isFlagDefinition(obj) {
  return obj && typeof obj.remoteFlagName === "string";
}
__name(isFlagDefinition, "isFlagDefinition");

// src/modules/container/constant/CONSTANTS.ts
var CONSTANTS;
((CONSTANTS2) => {
  CONSTANTS2.DEFAULT_APP_NAME = "cco";
  CONSTANTS2.APPD_NEXT_TENANT_ID = "appd-next-tenant-id";
  CONSTANTS2.APPD_NEXT_PRINCIPAL_ID = "appd-next-principal-id";
  CONSTANTS2.PLATFORM_APP_LAYERID = "platformapp";
  CONSTANTS2.SHELL_APP = "shell";
  CONSTANTS2.IDENTITY_API_URL_FOR_LOCAL = "https://identity-api.saas.appd-test.com/v3.0/accounts/sessions/me";
  CONSTANTS2.IDENTITY_API_URL = "https://identity-api.appdynamics.com/v3.0/accounts/sessions/me";
  CONSTANTS2.ZODIAC_MATCH_REGEX = "/app/([a-zA-Z0-9_]*)/([a-zA-Z0-9-_]*)/([a-zA-Z0-9-_]*)";
  CONSTANTS2.DIABLO_MATCH_REGEX = "/([a-zA-Z0-9_]*)/([a-zA-Z0-9-_]*)";
  CONSTANTS2.SHELL_FLAGS_STORE_KEY = "shell-feature-flags-store";
  CONSTANTS2.TRACE_PARENT = "traceparent";
  CONSTANTS2.TRACE_STATE = "tracestate";
  CONSTANTS2.TRACE_STATE_NAMESPACE = "ui";
  CONSTANTS2.COP_TENANT_ID = "COP_TENANT_ID";
})(CONSTANTS || (CONSTANTS = {}));

// src/modules/featureFlags/components/DevTool.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK2, DEFAULT_BG }
} = import_uik8.MAGNETIC_TOKENS;
var { RENDER_DEV_TOOL, DEV_TOOL_WRAPPER } = {
  RENDER_DEV_TOOL: (open) => import_uik8.css.Styles({
    display: open ? "block" : "none",
    transition: "height 200ms ease-out 0s"
  }),
  DEV_TOOL_WRAPPER: (showDevTool) => import_uik8.css.Styles({
    display: showDevTool ? "block" : "none",
    backgroundColor: DEFAULT_BG,
    borderSize: 2,
    borderStyle: "solid",
    borderColor: CONTROL_BORDER_WEAK2,
    cursor: "pointer"
  })
};
var DevTool = /* @__PURE__ */ __name(({
  className,
  isDevPage,
  featureFlagsStoreKey = CONSTANTS.SHELL_FLAGS_STORE_KEY,
  flagDefinitions
}) => {
  const [open, setOpen] = (0, import_react7.useState)(false);
  const [showDevTool, setShowDevTool] = (0, import_react7.useState)(
    isDevPage === void 0 ? localStorage.getItem(DEV_TOOL_STORE_KEY) === "enabled" : isDevPage
  );
  const handleClick = /* @__PURE__ */ __name(() => {
    localStorage.removeItem(DEV_TOOL_STORE_KEY);
    setShowDevTool(false);
  }, "handleClick");
  const handleStorageEvent = /* @__PURE__ */ __name((devToolStatus) => {
    if (devToolStatus === "enabled") {
      setShowDevTool(true);
    } else {
      setShowDevTool(false);
      localStorage.removeItem(DEV_TOOL_STORE_KEY);
    }
  }, "handleStorageEvent");
  (0, import_react7.useEffect)(() => {
    window.addEventListener("storage", (e) => {
      if (e.key === DEV_TOOL_STORE_KEY) {
        handleStorageEvent(e.newValue);
      }
    });
    return () => window.removeEventListener("storage", () => {
    });
  });
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: (0, import_uik8.css)({ ...DEV_TOOL_WRAPPER(showDevTool) }, className), children: [
    isDevPage === void 0 && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(DevToolBar, { open, onClick: () => setOpen((prev) => !prev), onCloseIconClick: handleClick }),
    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: (0, import_uik8.css)({ ...RENDER_DEV_TOOL(isDevPage !== void 0 ? isDevPage : open) }), children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(DevToolContent, { featureFlagsStoreKey, flagDefinitions }) })
  ] });
}, "DevTool");

// src/modules/featureFlags/components/FeatureFlagsProvider.tsx
var import_lib_featureflag = require("@appd/lib-featureflag");
var import_react8 = require("react");
var import_jsx_runtime9 = require("react/jsx-runtime");
var LAUNCH_DARKLY_CELL_ATTR_NAME = "cell";
var FeatureFlagsProvider = /* @__PURE__ */ __name(({
  enabled = false,
  config,
  children
}) => {
  const [flags, setFlags] = (0, import_react8.useState)();
  const [isLoading, setIsLoading] = (0, import_react8.useState)(true);
  (0, import_react8.useEffect)(() => {
    if (!enabled || config?.tenantId === "" || config?.tenantId === void 0 || config.launchDarklyClientId === "") {
      setIsLoading(false);
      return;
    }
    const isLocal = globalThis.location?.hostname === "localhost" || globalThis.location?.hostname === "127.0.0.1";
    const baseUrl = isLocal ? "https://app.launchdarkly.com" : `${globalThis.location.origin}/session/api/ext/featureFlags/v2`;
    const context = new import_lib_featureflag.FlagContext.Builder().setRegion(config.launchDarklyRegion).setTenant(config.tenantId).setCustomAttrs((/* @__PURE__ */ new Map()).set(LAUNCH_DARKLY_CELL_ATTR_NAME, config.cell)).build();
    globalThis.remoteFlagsPromise = import_lib_featureflag.FeatureFlag.getInstance(
      context,
      config.launchDarklyClientId,
      baseUrl,
      void 0,
      void 0,
      !isLocal,
      // send LD events only on non-local environments
      false
    );
    globalThis.remoteFlagsPromise.then((remoteFlags) => {
      initOrUpdateFlags(config.flagsStoreKey, config.flagDefinitions);
      setDefaultsFromRemote(config.flagsStoreKey, remoteFlags, config.flagDefinitions);
      setFlags(remoteFlags);
    }).catch(console.error).finally(() => setIsLoading(false));
  }, [enabled, config]);
  if (!enabled) {
    return children;
  }
  return isLoading ? null : /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(FeatureFlagContext.Provider, { value: flags, children });
}, "FeatureFlagsProvider");
function setDefaultsFromRemote(flagsStoreKey, flags, flagDefinitions) {
  Object.entries({ ...FLAG_DEFINITIONS_exports, ...flagDefinitions || {} }).map(
    ([localFlagName, { defaultValue, remoteFlagName }]) => remoteFlagName && setDefaultFlagValue(
      flagsStoreKey,
      localFlagName,
      typeof defaultValue === "boolean" ? flags.getBooleanFlagVariationDetail(remoteFlagName, String(defaultValue).toLowerCase() === "true").getValue() : flags.getJSONFlagVariationDetail(remoteFlagName, defaultValue).getValue()
    )
  );
}
__name(setDefaultsFromRemote, "setDefaultsFromRemote");
function migrateFeatureFlags(featureFlagsStoreKey) {
  const oldFeatureFlagData = globalThis.localStorage.getItem(OLD_NEXT_FEATURE_FLAG_STORE_KEY);
  if (oldFeatureFlagData) {
    globalThis.localStorage.setItem(featureFlagsStoreKey, oldFeatureFlagData);
    globalThis.localStorage.removeItem(OLD_NEXT_FEATURE_FLAG_STORE_KEY);
  }
}
__name(migrateFeatureFlags, "migrateFeatureFlags");
function initOrUpdateFlags(featureFlagsStoreKey, flagDefinitionsFromConfig) {
  if (globalThis.localStorage.getItem(featureFlagsStoreKey)) {
    updateFeatureFlagsFromDefinitions(featureFlagsStoreKey, flagDefinitionsFromConfig);
  } else if (featureFlagsStoreKey === "next-ui-feature-flags-store" && globalThis.localStorage.getItem(OLD_NEXT_FEATURE_FLAG_STORE_KEY)) {
    migrateFeatureFlags(featureFlagsStoreKey);
  } else {
    setDefaultFeatureFlags(featureFlagsStoreKey, flagDefinitionsFromConfig);
  }
}
__name(initOrUpdateFlags, "initOrUpdateFlags");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DEV_TOOL_STORE_KEY,
  DevTool,
  FeatureFlagGrid,
  FeatureFlagsProvider,
  createFlag,
  getFeatureFlags,
  getFlagValue,
  setDefaultFeatureFlags,
  setFlagValue,
  useFlagValue
});
//# sourceMappingURL=feature-flags.js.map
